import React, { useEffect, useState, useRef } from "react";

import jwtDecode from "jwt-decode";

import moment from "moment";

import * as XLSX from "xlsx";

import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";

import Loader from "../../../components/loader/loader";

import Snackbar from "../../../components/snackbar/snackbar";

import CustomTable from "../../../components/table/table";

import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";

import TextEditer from "../../../components/inputs/texteditor";

import {
  adminBulkEmailsList,
  superadminBulkEmailsList,
  adminBulkEmailDelete,
  superadminBulkEmailDelete,
  superadminBulkEmailDetail,
  superadminBulkEmailUpdate,
  send_bulk_emails,
} from "../admin.api";

import "./style.css";

const getStatusInfo = (status) => {
  const raw = status || "";

  const value = String(raw).toLowerCase();

  const statusMap = {
    sent: {
      label: "Sent",

      class: "successs",

      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      ),
    },

    submitted: {
      label: "Submitted",

      class: "info",

      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
        </svg>
      ),
    },

    failed: {
      label: "Failed",

      class: "danger",

      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>

          <line x1="15" y1="9" x2="9" y2="15"></line>

          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      ),
    },
  };

  const defaultIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>

      <line x1="12" y1="16" x2="12" y2="12"></line>

      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );

  let key = "secondary";

  if (value.includes("sent")) key = "sent";
  else if (value.includes("submit")) key = "submitted";
  else if (
    value.includes("fail") ||
    value.includes("error") ||
    value.includes("reject")
  )
    key = "failed";

  return (
    statusMap[key] || {
      label: raw?.charAt(0).toUpperCase() + raw?.slice(1),

      class: "secondary",

      icon: defaultIcon,
    }
  );
};

export default function BulkEmailsList(props) {
  const [data, setData] = useState([]);

  const [isActive, setIsActive] = useState(true);

  const [snackMessage, setSnackMessage] = useState("");

  const [isSnackError, setIsSnackError] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);

  const [page, setPage] = useState(1);

  const [perPage, setPerPage] = useState(10);

  const [totalPages, setTotalPages] = useState(1);

  const [showFilters, setShowFilters] = useState(false);

  const [filters, setFilters] = useState({
    status: "",
  });

  const [openAction, setOpenAction] = useState(false);

  const [activeData, setActiveData] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [editEmailUuid, setEditEmailUuid] = useState(null);

  const [isComposing, setIsComposing] = useState(false);

  const [editEditorKey, setEditEditorKey] = useState(0);

  const [fileInputKey, setFileInputKey] = useState(0);

  const [editSelectedFiles, setEditSelectedFiles] = useState([]);

  const [editExistingAttachments, setEditExistingAttachments] = useState([]);

  const [editFormData, setEditFormData] = useState({
    subject: "",

    body_html: "",

    body_text: "",

    metadata: {
      campaign: "",

      priority: "normal",
    },
  });

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const fetchBulkEmails = () => {
    setIsActive(true);

    const apiCall =
      adminType === 2
        ? superadminBulkEmailsList(page, perPage, filters)
        : adminBulkEmailsList(page, perPage, filters);

    apiCall

      .then((res) => {
        if (res?.success && res.data) {
          const pageData = res.data;
          const listData = Array.isArray(pageData) ? pageData : pageData.data || [];
          const lastPage = Array.isArray(pageData)
            ? 1
            : pageData.last_page || pageData?.pagination?.last_page || 1;

          listData.forEach((item, index) => {
            item["slno"] = (page - 1) * perPage + index + 1;
          });

          setData(listData);

          setTotalPages(lastPage);
        } else {
          setData([]);

          setTotalPages(1);
        }
      })

      .catch((error) => {
        console.error("Error fetching bulk emails:", error);

        setSnackMessage("Failed to load bulk emails");

        setIsSnackError(true);

        setSnackOpen(true);
      })

      .finally(() => {
        setIsActive(false);
      });
  };

  useEffect(() => {
    fetchBulkEmails();
  }, [page, perPage, filters]);

  const snackbarClose = (flag) => {
    setSnackMessage("");

    setIsSnackError(false);

    setSnackOpen(false);

    if (!flag) {
      fetchBulkEmails();
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({ ...prev, [name]: value }));

    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);

    setPage(1);
  };

  const renderPagination = () => {
    const pages = [];

    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));

    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button
          key={1}
          className="btn btn-sm btn-outline-primary"
          onClick={() => setPage(1)}
        >
          1
        </button>,
      );

      if (start > 2)
        pages.push(
          <span key="start-dots" className="px-1 text-primary">
            ...
          </span>,
        );
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>,
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1)
        pages.push(
          <span key="end-dots" className="px-1 text-primary">
            ...
          </span>,
        );

      pages.push(
        <button
          key={totalPages}
          className="btn btn-sm btn-outline-primary"
          onClick={() => setPage(totalPages)}
        >
          {totalPages}
        </button>,
      );
    }

    return pages;
  };

  const handleView = (row) => {
    if (!row?.uuid) return;

    props.history.push(`/bulk-emails/${row.uuid}`);
  };

  const handleCompose = () => {
    setIsComposing(true);

    setIsEditModalOpen(true);

    setEditEmailUuid(null);

    setEditFormData({
      subject: "",

      body_html: "",

      body_text: "",

      metadata: {
        campaign: "",

        priority: "normal",
      },
    });

    setEditExistingAttachments([]);

    setEditSelectedFiles([]);

    setEditEditorKey((prev) => prev + 1);
  };

  const handleEdit = (row) => {
    if (adminType !== 2 || !row?.uuid) return;

    setIsComposing(false);

    setIsEditModalOpen(true);

    setEditEmailUuid(row.uuid);

    setIsActive(true);

    superadminBulkEmailDetail(row.uuid)
      .then((res) => {
        const bulk = res?.data?.bulk_email;

        if (bulk) {
          let parsedMetadata = bulk.metadata || {};

          if (typeof parsedMetadata === "string") {
            try {
              parsedMetadata = JSON.parse(parsedMetadata);
            } catch (err) {
              parsedMetadata = {};
            }
          }

          setEditFormData({
            subject: bulk.subject || "",

            body_html: bulk.body_html || "",

            body_text: bulk.body_text || "",

            metadata: {
              campaign: parsedMetadata?.campaign || "",

              priority: parsedMetadata?.priority || "normal",
            },
          });

          setEditExistingAttachments(bulk.attachments || []);

          setEditEditorKey((prev) => prev + 1);
        }
      })

      .catch(() => {
        setSnackMessage("Failed to load bulk email for editing");

        setIsSnackError(true);

        setSnackOpen(true);

        setIsEditModalOpen(false);
      })

      .finally(() => {
        setIsActive(false);
      });
  };

  const handleEditFormChange = (field, value) => {
    if (field.includes(".")) {
      const [parent, child] = field.split(".");

      setEditFormData((prev) => ({
        ...prev,

        [parent]: {
          ...prev[parent],

          [child]: value,
        },
      }));
    } else {
      setEditFormData((prev) => ({
        ...prev,

        [field]: value,
      }));
    }
  };

  const handleEditModalClose = () => {
    setIsEditModalOpen(false);

    setEditEmailUuid(null);

    setIsComposing(false);
  };

  const handleEditSubmit = () => {
    if (adminType !== 2) return;

    setIsActive(true);

    const formData = new FormData();

    formData.append("subject", editFormData.subject);

    formData.append("body_html", editFormData.body_html);

    formData.append("body_text", editFormData.body_text);

    formData.append("metadata[campaign]", editFormData.metadata.campaign);

    formData.append("metadata[priority]", editFormData.metadata.priority);

    editSelectedFiles.forEach((file) => {
      formData.append("documents[]", file);
    });

    const apiCall = isComposing
      ? send_bulk_emails(formData)
      : superadminBulkEmailUpdate(editEmailUuid, formData);

    apiCall

      .then((res) => {
        setSnackMessage(
          res?.message ||
            (isComposing
              ? "Bulk email sent successfully"
              : "Bulk email updated successfully"),
        );

        setIsSnackError(false);

        setSnackOpen(true);

        handleEditModalClose();

        fetchBulkEmails();
      })

      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
            error?.message ||
            "Operation failed",
        );

        setIsSnackError(true);

        setSnackOpen(true);
      })

      .finally(() => {
        setIsActive(false);
      });
  };

  const handleEditFileChange = (e) => {
    const files = Array.from(e.target.files);

    const maxSize = 5 * 1024 * 1024; // 5 MB

    const oversized = files.filter((f) => f.size > maxSize);

    if (oversized.length > 0) {
      setSnackMessage(`File size must be less than 5 MB`);

      setIsSnackError(true);

      setSnackOpen(true);

      e.target.value = "";

      return;
    }

    setEditSelectedFiles(files);
  };

  const handleDeleteClick = (row) => {
    setActiveData(row);

    setOpenAction(true);
  };

  const handleConfirmDelete = () => {
    if (!activeData?.uuid) {
      setOpenAction(false);

      return;
    }

    setIsActive(true);

    const deleteCall =
      adminType === 2
        ? superadminBulkEmailDelete(activeData.uuid)
        : adminBulkEmailDelete(activeData.uuid);

    deleteCall

      .then((res) => {
        setSnackMessage(res?.message || "Bulk email deleted successfully");

        setIsSnackError(res?.success === false);

        setSnackOpen(true);
      })

      .catch((error) => {
        setSnackMessage(error?.response?.data?.message || "Failed to delete");

        setIsSnackError(true);

        setSnackOpen(true);
      })

      .finally(() => {
        setIsActive(false);

        setOpenAction(false);

        setActiveData(null);

        fetchBulkEmails();
      });
  };

  const downloadExcel = () => {
    if (!data.length) {
      setSnackMessage("No data to download");

      setIsSnackError(true);

      setSnackOpen(true);

      return;
    }

    const exportData = data.map((item) => ({
      "Sl No": item.slno,

      Category: item.user_category || "--",

      Subject: item.subject || "--",

      Recipients: item.total_recipients || 0,

      Status: getStatusInfo(item.status).label,

      Date: item.created_at
        ? moment(item.created_at).format("DD-MMM-YYYY")
        : "--",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Emails");

    XLSX.writeFile(workbook, "Bulk_Emails.xlsx");
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Bulk Emails</b>
          </h5>

          <div className="d-flex gap-2">
            {/* {adminType === 2 && (



              <button className="btn btn-primary btn-sm" onClick={handleCompose}>



                Compose Email



              </button>



            )} */}

            <button className="btn btn-primary btn-sm" onClick={downloadExcel}>
              Download Excel
            </button>

            <button
              className={`filter-icon-btn ${showFilters ? "active" : ""}`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end">
              <div className="col-md-3">
                <label className="form-label small">Status</label>

                <select
                  name="status"
                  className="form-control filter-select"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Statuses</option>

                  <option value="sent">Sent</option>

                  <option value="submitted">Submitted</option>

                  <option value="failed">Failed</option>
                </select>
              </div>

              <div className="col-md-2 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset"
                  onClick={() => {
                    setFilters({ status: "" });

                    setPage(1);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>

                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>

                <button
                  className="filter-action-btn close-btn"
                  onClick={() => setShowFilters(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>

                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <CustomTable
            {...props}
            columns={[
              { title: "Sl No", field: "slno", width: "50px" },

              { title: "User Category", field: "user_category" },

              { title: "Subject", field: "subject" },

              {
                title: "Recipients",
                field: "total_recipients",
                render: (row) => row.total_recipients ?? "0",
              },

              {
                title: "Status",

                field: "status",

                render: (row) => {
                  const info = getStatusInfo(row.status);

                  return (
                    <span className={`status-badge ${info.class}`}>
                      <span className="status-icon">{info.icon}</span>

                      <span className="status-label">{info.label}</span>
                    </span>
                  );
                },
              },

              {
                title: "Action",

                render: (row) => (
                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-outline-primary action-btn"
                      onClick={() => handleView(row)}
                      title="View"
                    >
                      <FiEye size={16} />
                    </button>

                    {adminType === 2 && (
                      <>
                        <button
                          className="btn btn-sm btn-outline-info action-btn"
                          onClick={() => handleEdit(row)}
                          title="Edit"
                        >
                          <FiEdit size={16} />
                        </button>

                        <button
                          className="btn btn-sm btn-outline-danger action-btn"
                          onClick={() => handleDeleteClick(row)}
                          title="Delete"
                        >
                          <FiTrash2 size={16} />
                        </button>
                      </>
                    )}
                  </div>
                ),
              },
            ]}
            data={data}
            paging={false}
          />

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="flex-grow-1"></div>

            <div className="btn-group">
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Prev
              </button>

              {renderPagination()}

              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Next
              </button>
            </div>

            <div className="flex-grow-1 d-flex justify-content-end">
              <select
                className="form-control form-control-sm w-auto"
                value={perPage}
                onChange={handlePerPageChange}
                style={{ height: "31px", fontSize: "8px" }}
              >
                <option value="5">5</option>

                <option value="10">10</option>

                <option value="25">25</option>

                <option value="50">50</option>
                <option value="all">All</option>
              </select>
            </div>
          </div>
        </div>

        {openAction && (
          <ConfirmDialog
            open={openAction}
            title="Delete Bulk Email?"
            data={activeData}
            message="Are you sure you want to delete this bulk email?"
            secondary_action="Cancel"
            primary_action="Delete"
            handleClose={() => setOpenAction(false)}
            handleConfirm={handleConfirmDelete}
          />
        )}
      </div>

      {isEditModalOpen && (
        <div
          className="modal-backdrop"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "1rem",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              width: "100%",
              maxWidth: "900px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <div className="modal-header bg-primary text-white p-3 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                {isComposing ? "Compose Email" : "Edit Email"}
              </h5>

              <button
                type="button"
                className="btn-close text-white"
                onClick={handleEditModalClose}
                style={{ background: "none", border: "none", fontSize: "24px" }}
              >
                ×
              </button>
            </div>

            <div className="modal-body p-4">
              <div className="mb-3">
                <label className="form-label">
                  Subject <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={editFormData.subject}
                  onChange={(e) =>
                    handleEditFormChange("subject", e.target.value)
                  }
                  placeholder="Enter email subject"
                />
              </div>

              <div className="mb-3">
                <TextEditer
                  label={
                    <>
                      Message <span className="text-danger">*</span>
                    </>
                  }
                  key={`edit-html-${editEditorKey}`}
                  value={editFormData.body_html}
                  onChange={(value) => handleEditFormChange("body_html", value)}
                  required
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Campaign</label>

                  <input
                    type="text"
                    className="form-control"
                    value={editFormData.metadata.campaign}
                    onChange={(e) =>
                      handleEditFormChange("metadata.campaign", e.target.value)
                    }
                    placeholder="Campaign name"
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Priority</label>

                  <select
                    className="form-select"
                    value={editFormData.metadata.priority}
                    onChange={(e) =>
                      handleEditFormChange("metadata.priority", e.target.value)
                    }
                  >
                    <option value="normal">Normal</option>

                    <option value="high">High</option>

                    <option value="low">Low</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Attachments</label>

                {editExistingAttachments.length > 0 && (
                  <div className="mb-2">
                    <small className="text-muted">Existing attachments:</small>

                    {editExistingAttachments.map((att, index) => (
                      <div key={index} className="mt-1">
                        <small className="text-success">
                          {att.name} ({(att.size / 1024).toFixed(2)} KB)
                        </small>
                      </div>
                    ))}
                  </div>
                )}

                <input
                  key={fileInputKey}
                  type="file"
                  className="form-control"
                  multiple
                  onChange={handleEditFileChange}
                />

                {editSelectedFiles.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">Files to upload:</small>

                    {editSelectedFiles.map((file, index) => (
                      <div key={index} className="mt-1">
                        <small className="text-primary">
                          {file.name} ({(file.size / 1024).toFixed(2)} KB)
                        </small>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer p-3 border-top d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-secondary w-25"
                onClick={handleEditModalClose}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-secondary w-25"
                onClick={handleEditSubmit}
                disabled={!editFormData.subject || !editFormData.body_html}
              >
                {isComposing ? "Send Email" : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
